import { addDays, format } from "date-fns";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { BsInfoCircle } from "react-icons/bs";
import { IoCloseCircleOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import * as Yup from "yup";
import orgApi from "../../../api/org_api";
import {
  Button,
  CustomDatePicker,
  CustomInput,
  FileUpload,
  Label,
  Modal,
  MultiSelectDropdown,
  SearchableDropdown,
  TextArea,
  Tooltip,
} from "../../../component/common";
import { Timer } from "../../../Services";
import { cn } from "../../../utils/lib";

type UploadJdProps = {
  setLoading: Function;
  setPostId: Function;
  postId: string;
};

const UploadJd = ({ setLoading, setPostId, postId }: UploadJdProps) => {
  const [jdTemplate, setJdTemplate] = useState<any>([]);
  const [roleTemplate, setRoleTemplate] = useState<any>([]);
  const [skillList, setSkillList] = useState<any>([]);
  const [validity_error, setValidityError] = useState<string>("");
  const [primary, setPrimary] = useState<any>([]);
  const [secondary, setSecondary] = useState<any>([]);
  const [selectedFile, setSelectedFile] = useState<File>();
  const [fileError, setfileError] = useState<string>("");
  const [validity, setSelectedDate] = useState<Date | null>(null);
  const [secondary_error, serSecondaryError] = useState<string>("");
  const [primary_error, serPrimaryError] = useState<string>("");
  const [selectedJdTemplate, setSelectedTemplate] = useState<string>("");
  const [templateJdattachment, setTemplateJdattachment] = useState<string>("");
  const [showJdAttachment, setShowJdAttachment] = useState<boolean>(true);
  const [createdForClient, setCreatedForClient] = useState<boolean>(false);
  const [enableTemplate, setEnableTemplate] = useState<boolean>(false);
  const year_options = Array.from({ length: 20 }, (_, index) => index + 1);
  const month_options = Array.from({ length: 11 }, (_, index) => index + 1);
  const [showTemplate, setShowTemplate] = useState<boolean>(false);
  const [values, setValues] = useState<any>({});
  const [templateConfirmation, setTemplateConfirmation] =
    useState<boolean>(false);
  const [isDisabled, setisDisabled] = useState<boolean>(false);
  const [addBU, setAddBU] = useState<boolean>(false);
  const [businessUnitList, setBusinessUnit] = useState<any>([]);
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [jdSelectionDropdown, setJdSelectionDropdown] = useState<string>("");

  const userInfo = JSON.parse(
    localStorage.getItem("user__details")?.toString()!,
  );

  const locationList = [
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
  ];

  useEffect(() => {
    getBusinessUnit();
    setShowTemplate(true);
    openIdForm();
  }, []);

  const getJdDetails = async (pId: any) => {
    const res1 = await orgApi.getSingleJdDetail(pId);
    var templatedata = res1.data.post;
    if (!templatedata) {
      setLoading(false);
      return;
    }
    if (templatedata["client_name"]) {
      formik.setFieldValue("client_name", templatedata["client_name"]);
      formik.setFieldValue("client_email", templatedata["client_email"]);
    }
    formik.setFieldValue("title", templatedata["job_title"]);
    formik.setFieldValue("ats_number", templatedata["ats_number"]);
    formik.setFieldValue("exp_year", templatedata["year_of_experience"]);
    formik.setFieldValue("exp_month", templatedata["month_of_experience"]);
    formik.setFieldValue(
      "business_unit",
      templatedata["business_unit_id"] ? templatedata["business_unit_id"] : "",
    );
    formik.setFieldValue(
      "location",
      templatedata["location"] ? templatedata["location"] : "",
    );
    const tenDaysLater = new Date(templatedata["post_validity"]);
    setSelectedDate(tenDaysLater);
    var primarySkill = [];
    for (let i = 0; i < templatedata["template"]["t_p_skill"].length; i++) {
      primarySkill.push({
        id: templatedata["template"]["t_p_skill"][i]["skill_id"],
        name: templatedata["template"]["t_p_skill"][i]["skill"]["name"],
        year: 0,
        month: 0,
        weightage: templatedata["template"]["t_p_skill"][i]["weightage"],
        weightage_error: "",
      });
    }
    setPrimary(primarySkill);
    formik.setFieldValue("primary_skill", primarySkill);
    var secondarySkill = [];
    for (let i = 0; i < templatedata["template"]["t_s_skill"].length; i++) {
      secondarySkill.push({
        id: templatedata["template"]["t_s_skill"][i]["skill_id"],
        name: templatedata["template"]["t_s_skill"][i]["skill"]["name"],
        year: 0,
        month: 0,
        weightage: templatedata["template"]["t_s_skill"][i]["weightage"],
        weightage_error: "",
      });
    }
    setSecondary(secondarySkill);
    formik.setFieldValue("secondary_skill", secondarySkill);
    formik.setFieldValue("opening", templatedata["no_of_candidate"]);
    formik.setFieldValue(
      "job_description",
      templatedata["template"]["description"],
    );
    formik.setFieldValue("remarks", templatedata["remarks"]);
    setTemplateJdattachment(templatedata["template"]["attachment"]);
    templatedata["template"]["description"] && setShowJdAttachment(false);
    setLoading(false);
  };
  useEffect(() => {
    if (postId === null || postId === undefined || postId === "")
      templateSelection();
  }, [enableTemplate === true, postId]);
  const getSkills = async () => {
    setLoading(true);
    const data = { search: "" };
    const res = await orgApi.skills(data);
    setSkillList(res.data.skills);
    setLoading(false);
  };
  const openIdForm = async () => {
    formik.resetForm();
    await getSkills();
    const tenDaysLater = addDays(new Date(), 10);
    setSelectedDate(tenDaysLater);
    setPrimary([]);
    setSecondary([]);
    setLoading(false);
    if (postId !== null && postId !== undefined && postId !== "") {
      setShowTemplate(false);
      getJdDetails(postId);
    } else await getRoles();
  };
  const getRoles = async () => {
    setLoading(true);
    const res = await orgApi.roleTemplate();
    setLoading(false);
    if (res.data.success) setRoleTemplate(res.data.role_tem);
    else setRoleTemplate([]);
  };
  const setTemplateData = async (templateId: any) => {
    if (templateId !== "") {
      resetJd();
      setLoading(true);
      const res1 = await orgApi.templateDetail(templateId);
      var templatedata = res1.data.tem[0];
      formik.setFieldValue("title", templatedata["name"]);
      var primarySkill = [];
      for (let i = 0; i < templatedata["t_p_skill"].length; i++) {
        primarySkill.push({
          id: templatedata["t_p_skill"][i]["skill_id"],
          name: templatedata["t_p_skill"][i]["skill"]["name"],
          year: 0,
          month: 0,
          weightage: templatedata["t_p_skill"][i]["weightage"],
          weightage_error: "",
        });
      }
      setPrimary(primarySkill);
      formik.setFieldValue("primary_skill", primarySkill);
      var secondarySkill = [];
      for (let i = 0; i < templatedata["t_s_skill"].length; i++) {
        secondarySkill.push({
          id: templatedata["t_s_skill"][i]["skill_id"],
          name: templatedata["t_s_skill"][i]["skill"]["name"],
          year: 0,
          month: 0,
          weightage: templatedata["t_s_skill"][i]["weightage"],
          weightage_error: "",
        });
      }
      setSecondary(secondarySkill);
      formik.setFieldValue("secondary_skill", secondarySkill);
      formik.setFieldValue("job_description", templatedata["description"]);
      setTemplateJdattachment(templatedata["attachment"]);
      templatedata["description"] && setShowJdAttachment(false);
      setLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      title: "",
      exp_year: 6,
      exp_month: 0,
      opening: 1,
      job_description: "",
      remarks: "",
      client_name: "",
      client_email: "",
      primary_skill: [] as any,
      secondary_skill: [] as any,
      business_unit: "",
      location: "",
      ats_number: "",
      new_business_unit: "",
      additional_skill: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      exp_year: Yup.number().required("Year is required"),
      exp_month: Yup.number().required("Month is required"),
      opening: Yup.number().required("Opening is required"),
      job_description: Yup.string().required("Job Description is required"),
      remarks: Yup.string(),
      primary_skill: Yup.array().required("Select Required Technical Skills"),
      secondary_skill: Yup.array().required(
        "Select Preferred Technical Skills",
      ),
      client_name: createdForClient
        ? Yup.string().required("Client Name is required")
        : Yup.string(),
      business_unit: Yup.string(),
      ats_number: Yup.string()
        .min(7, "ATS Number should be 7 digit")
        .max(7, "ATS Number should be 7 digit"),
      new_business_unit: Yup.string(),
      additional_skill: Yup.string().max(
        25,
        "Skill name must be maximum 25 characters",
      ),
    }),
    validateOnBlur: true,
    onSubmit: async (values) => {
      setValues(values);
      if (selectedJdTemplate) setTemplateConfirmation(true);
      else submitPost(values);
    },
  });

  const submitPost = async (values: any) => {
    setTemplateConfirmation(false);
    if (validity) setValidityError("");
    else {
      setValidityError("Please select the validity");
      return;
    }

    if (primary.length === 0) {
      serPrimaryError("Select Required Technical Skills");
      return;
    } else serPrimaryError("");
    if (secondary.length === 0) {
      serSecondaryError("Select Preferred Technical Skills");
      return;
    } else serSecondaryError("");

    var flag = 0;
    var primarySkill = [] as any;
    for (let i = 0; i < primary.length; i++) {
      if (primary[i]["weightage"] === 0) {
        primary[i]["weightage_error"] = "Please enter the weightage";
        setPrimary(primary);
      }
      if (primary[i]["weightage_error"] !== "") {
        flag = 1;
        break;
      }
      primarySkill.push({
        skill_id: primary[i]["id"],
        year: primary[i]["year"],
        month: primary[i]["month"],
        weightage: Number(primary[i]["weightage"]),
      });
    }
    if (flag === 1) return;
    const secondarySkill = [] as any;
    for (let i = 0; i < secondary.length; i++) {
      if (secondary[i]["weightage"] === 0) {
        secondary[i]["weightage_error"] = "Please enter the weightage";
        setSecondary(secondary);
      }
      if (secondary[i]["weightage_error"] !== "") {
        flag = 1;
        break;
      }
      secondarySkill.push({
        skill_id: secondary[i]["id"],
        year: secondary[i]["year"],
        month: secondary[i]["month"],
        weightage: Number(secondary[i]["weightage"]),
      });
    }
    if (flag === 1) return;
    const userDetails = localStorage.getItem("user__details");
    const userInfo = userDetails ? JSON.parse(userDetails) : {};
    const orgId = userInfo.id;
    const userId = localStorage.getItem("user_id")?.toString();
    const formattedDate = format(validity, "yyyy-MM-dd");

    const reqData: any = {
      job_title: values.title,
      post_validity: formattedDate,
      year_of_experience: values.exp_year,
      month_of_experience: values.exp_month,
      name: selectedJdTemplate !== "" ? "" : values.title,
      description: values.job_description,
      primary: selectedJdTemplate !== "" ? "" : primarySkill,
      secondary: selectedJdTemplate !== "" ? "" : secondarySkill,
      job_comments: values.job_description,
      remarks: values.remarks,
      no_of_candidate: values.opening,
      user_id: userId,
      client_name: values.client_name,
      client_email: values.client_email,
      ats_number: values.ats_number,
      business_unit_id:
        values.business_unit === "" ? null : values.business_unit,
      location: values.location,
    };
    selectedJdTemplate && (reqData.template_id = selectedJdTemplate);
    setisDisabled(true);
    setLoading(true);
    if (showTemplate) {
      const res = await orgApi.addPost(orgId, reqData);
      if (res.data.success) {
        const postId1 = res.data.post.id;
        localStorage.setItem("createPostId", postId1);
        if (
          showJdAttachment &&
          selectedFile !== undefined &&
          selectedFile !== null
        ) {
          const templateId = res.data.post.template_id;
          const formData = new FormData();
          formData.append("jd", selectedFile!);
          const res1 = await orgApi.uploadJd(templateId, formData);
          setisDisabled(false);
          setLoading(false);
          if (res1.data.success) {
            toast("JD created successfully");
            setSelectedFile(undefined);
            setPrimary([]);
            setSecondary([]);
            setTemplateJdattachment("");
            setShowJdAttachment(true);
            setPostId(postId1);
          }
        } else {
          setisDisabled(false);
          setLoading(false);
          toast("JD created successfully");
          setSelectedFile(undefined);
          setPrimary([]);
          setSecondary([]);
          setTemplateJdattachment("");
          setShowJdAttachment(true);
          setPostId(postId1);
        }
      }
    } else {
      const res = await orgApi.editPost(
        localStorage.getItem("createPostId")!,
        reqData,
      );
      if (res.data.success) {
        const postId1 = res.data.post.id;
        if (showJdAttachment) {
          const templateId = res.data.post.template_id;
          const formData = new FormData();
          formData.append("jd", selectedFile!);
          const res1 = await orgApi.uploadJd(templateId, formData);
          setLoading(false);
          if (res1.data.success) {
            toast("JD edited successfully");
            setSelectedFile(undefined);
            setPrimary([]);
            setSecondary([]);
            setTemplateJdattachment("");
            setShowJdAttachment(true);
            setTimeout(() => {
              setisDisabled(false);
              setPostId(postId1);
            }, 1000);
          }
        } else {
          setLoading(false);
          toast("JD edited successfully");
          setSelectedFile(undefined);
          setPrimary([]);
          setSecondary([]);
          setTemplateJdattachment("");
          setShowJdAttachment(true);
          setTimeout(() => {
            setisDisabled(false);
            setPostId(postId1);
          }, 1000);
        }
      }
    }
  };
  const handleDateChange = (date: any) => {
    setValidityError("");
    setSelectedDate(date);
  };
  const resetJd = () => {
    formik.resetForm();
    setSelectedFile(undefined);
    setPrimary([]);
    setSecondary([]);
    const tenDaysLater = addDays(new Date(), 10);
    setSelectedDate(tenDaysLater);
  };

  const resetClientAndTemplate = () => {
    setJdSelectionDropdown("");
    setSelectedRole("");
    setEnableTemplate(false);
    setShowJdAttachment(true);
    setCreatedForClient(false);
  };

  const handleImageChange = async (event: any) => {
    setfileError("");
    const file = event;
    if (file) {
      if (
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/pdf"
      ) {
        if (file.size <= 3 * 1024 * 1024) {
          setSelectedFile(file);
          const formData = new FormData();
          formData.append("file", file);
          const res = await orgApi.fileReader(formData);
          if (res.data.success) {
            formik.setFieldValue("job_description", res.data.str);
            setfileError("");
          } else {
            toast.warning(res.data.msg);
          }
        } else {
          setfileError("Please upload the file with size <3 MB");
          setSelectedFile(undefined);
        }
      } else {
        setfileError("Please upload only pdf or docx format");
        setSelectedFile(undefined);
      }
    }
  };
  const handleChangeJdTemplate = (event: any) => {
    resetJd();
    setSelectedTemplate(event);
    setTemplateData(event);
  };
  const handleChangeRoleTemplate = async (event: any) => {
    setLoading(true);
    resetJd();
    const res = await orgApi.roleTemplateSkill(event);
    setLoading(false);
    if (res.data.success) {
      const templatedata = res.data.role_tem[0];
      formik.setFieldValue("title", templatedata["name"]);
      const t_len =
        templatedata["r_p_skill"].length + templatedata["r_s_skill"].length;
      let wtg = 0;
      wtg = 100 / t_len;
      let add = 0;
      if (Math.floor(wtg) * t_len < 100) {
        add = 100 - Math.floor(wtg) * t_len;
      }
      let primarySkill = [];
      for (let i = 0; i < templatedata["r_p_skill"].length; i++) {
        primarySkill.push({
          id: templatedata["r_p_skill"][i]["skill_id"],
          name: templatedata["r_p_skill"][i]["skill"]["name"],
          year: 0,
          month: 0,
          weightage: i === 0 ? Math.floor(wtg) + add : Math.floor(wtg),
          weightage_error: "",
        });
      }
      setPrimary(primarySkill);
      formik.setFieldValue("primary_skill", primarySkill);
      let secondarySkill = [];
      for (let i = 0; i < templatedata["r_s_skill"].length; i++) {
        if (templatedata["r_p_skill"].length == 0) {
          secondarySkill.push({
            id: templatedata["r_s_skill"][i]["skill_id"],
            name: templatedata["r_s_skill"][i]["skill"]["name"],
            year: 0,
            month: 0,
            weightage: i === 0 ? Math.floor(wtg) + add : Math.floor(wtg),
            weightage_error: "",
          });
        } else {
          secondarySkill.push({
            id: templatedata["r_s_skill"][i]["skill_id"],
            name: templatedata["r_s_skill"][i]["skill"]["name"],
            year: 0,
            month: 0,
            weightage: Math.floor(wtg),
            weightage_error: "",
          });
        }
      }
      setSecondary(secondarySkill);
      formik.setFieldValue("secondary_skill", secondarySkill);
    }
  };
  const templateSelection = async () => {
    if (!enableTemplate) {
      setSelectedTemplate("");
      setTemplateData("");
      resetJd();
    } else {
      setLoading(true);
      const userDetails = localStorage.getItem("user__details");
      const userInfo = userDetails ? JSON.parse(userDetails) : {};
      const orgId =
        userInfo.master_id !== null ? userInfo.master_id : userInfo.id;
      const data = { search: "", org_id: orgId };
      const res = await orgApi.jdTemplate(orgId, data);
      setLoading(false);
      if (res.data.success) {
        setJdTemplate(res.data.tem);
      } else {
        toast("Template not found");
        setJdTemplate([]);
        setSelectedTemplate("");
        setTemplateData("");
        resetJd();
        setTimeout(() => {
          setEnableTemplate(false);
        }, 1500);
      }
    }
  };

  const getBusinessUnit = async () => {
    const userDetails = localStorage.getItem("user__details");
    const userInfo = userDetails ? JSON.parse(userDetails) : {};
    const orgId =
      userInfo.master_id !== null ? userInfo.master_id : userInfo.id;
    const res = await orgApi.getBusinessUnit(orgId);
    res.data.success
      ? setBusinessUnit(res.data.business_unit)
      : setBusinessUnit([]);
  };
  const addNewBu = async () => {
    if (formik.getFieldProps("new_business_unit").value === "") {
      return;
    }
    const userDetails = localStorage.getItem("user__details");
    const userInfo = userDetails ? JSON.parse(userDetails) : {};
    const orgId =
      userInfo.master_id !== null ? userInfo.master_id : userInfo.id;
    const reqData = {
      name: formik.getFieldProps("new_business_unit").value,
      org_id: orgId,
    };
    const res = await orgApi.addBusinessUnit(orgId, reqData);
    if (res.data.success) {
      toast(res.data.msg);
      getBusinessUnit();
      setAddBU(false);
      formik.setFieldValue("new_business_unit", "");
      formik.setFieldValue("business_unit", res.data.business_unit.id);
    } else {
      toast(res.data.msg);
    }
  };
  const addNewSkill = async () => {
    const reqData = {
      name: formik.getFieldProps("additional_skill").value.trim(),
    };
    const res = await orgApi.addAdditionalSkill(reqData);
    if (res.data.success) {
      toast(res.data.msg);
      getSkills();
      formik.setFieldValue("additional_skill", "");
    } else {
      toast(res.data.msg);
    }
  };

  const handleAccountToggle = (value: boolean) => {
    setCreatedForClient(value);
  };
  return (
    <>
      {templateConfirmation && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="fixed inset-0 w-full h-full bg-black opacity-40"></div>
            <div className="flex items-center  min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white shadow-lg rounded-sm rounded-br-3xl">
                <div className="sm:flex">
                  <div className="mt-1 text-center sm:text-left w-full">
                    <div className=" w-full mt-4 max-w-lg text-xs text-gray-500 font-normal">
                      JD will be created using this template
                    </div>

                    <div className=" gap-2 mt-3 sm:flex md:flex lg:flex flex-row-reverse">
                      <button
                        className="mt-2 py-1 px-2.5 text-white button-primary outline-none text-sm"
                        onClick={() => submitPost(values)}
                      >
                        Proceed
                      </button>
                      <button
                        className=" mt-2 py-1 px-2.5 text-gray-800 outline-none border text-sm"
                        onClick={() => setTemplateConfirmation(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <form onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-2 lg:grid-cols-4  gap-4 p-2">
          <div
            className={cn(
              "flex flex-col col-span-2 gap-2 p-3 border rounded-lg transition-all duration-200",
              enableTemplate
                ? "border-blue-400 bg-blue-50 shadow-sm shadow-blue-100"
                : "border-gray-200 bg-gray-50",
            )}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <label className="relative flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only"
                    checked={enableTemplate}
                    onChange={(e) => setEnableTemplate(e.target.checked)}
                  />
                  <div
                    className={cn(
                      "w-4 h-4 border-2 rounded-full flex items-center justify-center transition-all duration-200",
                      enableTemplate
                        ? "border-blue-500 bg-blue-500"
                        : "border-gray-400 bg-white",
                    )}
                  >
                    {enableTemplate && (
                      <div className="w-2 h-2 bg-white rounded-full" />
                    )}
                  </div>
                </label>
                <Label
                  text={"Need Existing Templates"}
                  className={cn(
                    "font-semibold transition-colors duration-200",
                    enableTemplate ? "text-blue-700" : "text-gray-600",
                  )}
                />
              </div>
            </div>
            <div className=" flex justify-between items-center gap-4">
              <div className="w-full">
                <SearchableDropdown
                  options={
                    jdTemplate?.length > 0
                      ? jdTemplate.map((val: any) => ({
                          label: `${val.name} - ${Timer.getDate(
                            val.created_on,
                          )}`,
                          value: val.id,
                        }))
                      : []
                  }
                  value={jdSelectionDropdown}
                  label="Select by Own Template"
                  placeholder="Choose a template..."
                  onChange={(e: any) => {
                    handleChangeJdTemplate(e.value);
                    setJdSelectionDropdown(e.value);
                  }}
                  isSearchable
                  className={cn("w-full", !enableTemplate ? "opacity-50" : "")}
                  disabled={!enableTemplate || !!selectedRole}
                  isClearable
                />
              </div>
              <div className="w-full">
                <SearchableDropdown
                  label="Select by Role"
                  placeholder="Choose a role..."
                  options={roleTemplate?.map((item: any) => ({
                    label: item.name,
                    value: item.id,
                  }))}
                  value={selectedRole}
                  onChange={(e: any) => {
                    handleChangeRoleTemplate(e.value);
                    setSelectedRole(e.value);
                  }}
                  isSearchable
                  className={cn("w-full", !enableTemplate ? "opacity-50" : "")}
                  disabled={!enableTemplate || !!jdSelectionDropdown}
                  isClearable
                />
              </div>
            </div>
          </div>
          <div
            className={cn(
              "flex flex-col col-span-2 gap-2 p-2 border rounded-lg transition-all duration-200",
              createdForClient
                ? "border-blue-400 bg-blue-50 shadow-sm shadow-blue-100"
                : "border-gray-200 bg-gray-50",
            )}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <label className="relative flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only"
                    checked={createdForClient}
                    onChange={(e) => handleAccountToggle(e.target.checked)}
                  />
                  <div
                    className={cn(
                      "w-4 h-4 border-2 rounded-full flex items-center justify-center transition-all duration-200",
                      createdForClient
                        ? "border-blue-500 bg-blue-500"
                        : "border-gray-400 bg-white",
                    )}
                  >
                    {createdForClient && (
                      <div className="w-2 h-2 bg-white rounded-full" />
                    )}
                  </div>
                </label>
                <Label
                  text={"Creating for Client"}
                  className={cn(
                    "font-semibold transition-colors duration-200",
                    createdForClient ? "text-blue-700" : "text-gray-600",
                  )}
                />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <CustomInput
                  label="Client Name"
                  name="client_name"
                  type="text"
                  placeholder="Enter Client Name"
                  value={formik.values.client_name}
                  onChange={formik.handleChange}
                  isError={
                    !!formik.touched.client_name && !!formik.errors.client_name
                  }
                  errorMessage={formik.errors.client_name}
                  required
                  disabled={!createdForClient}
                  className={!createdForClient ? "opacity-50" : ""}
                />
              </div>

              <div className="flex-1">
                <CustomInput
                  label="Client Email"
                  name="client_email"
                  type="email"
                  placeholder="Enter Client Email"
                  value={formik.values.client_email}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  disabled={!createdForClient}
                  className={!createdForClient ? "opacity-50" : ""}
                />
              </div>
            </div>
          </div>

          <CustomInput
            label="Title"
            name="title"
            type="text"
            value={formik.values.title}
            disabled={selectedJdTemplate !== "" ? true : false}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            isError={!!formik.touched.title && !!formik.errors.title}
            errorMessage={formik.errors.title}
            required
          />

          <CustomDatePicker
            label="Validity"
            selected={validity}
            onChange={handleDateChange}
            onBlur={formik.handleBlur}
            dateFormat="dd MMM, yyyy"
            isClearable
            placeholderText="Select validity"
            onKeyDown={(e) => {
              e.preventDefault();
            }}
            required
            isError={!!validity_error}
            errorMessage={validity_error}
          />

          <div className="flex flex-col gap-1.5">
            <Label text="Overall Experience" required />
            <div className="flex items-center justify-between gap-2">
              <SearchableDropdown
                className="w-full"
                placeholder="Select Year"
                options={year_options.map((number) => ({
                  label: number.toString(),
                  value: number.toString(),
                }))}
                value={formik.values.exp_year.toString()}
                onChange={(e: any) => {
                  formik.setFieldValue("exp_year", e.value);
                }}
              />
              <SearchableDropdown
                placeholder="Select Month"
                className="w-full"
                options={month_options.map((number) => ({
                  label: number.toString(),
                  value: number.toString(),
                }))}
                value={formik.values.exp_month.toString()}
                onChange={(e: any) => {
                  formik.setFieldValue("exp_month", e.value);
                }}
              />
            </div>
          </div>

          <div className="flex gap-2">
            <CustomInput
              label="Opening"
              name="opening"
              type="number"
              value={formik.values.opening}
              onChange={formik.handleChange}
              isError={!!formik.touched.opening && !!formik.errors.opening}
              errorMessage={formik.errors.opening}
              required
            />

            <CustomInput
              label="ATS Number"
              name="ats_number"
              type="text"
              value={formik.values.ats_number}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />
          </div>

          {userInfo.org_name === "NAM IT" ? (
            <div className="flex flex-col gap-1.5">
              <Label text="Location" />
              <SearchableDropdown
                className="w-full"
                placeholder="Select Location"
                options={locationList}
                value={formik.values.location}
                onChange={(e: any) => {
                  formik.setFieldValue("location", e.value);
                }}
              />
            </div>
          ) : (
            <div className="flex flex-col gap-1.5">
              <Label text="Business Unit" />
              <div className="flex items-center gap-2">
                <SearchableDropdown
                  placeholder="Select Business Unit"
                  options={businessUnitList.map((e: any) => ({
                    value: e.id,
                    label: e.name,
                  }))}
                  value={formik.values.business_unit}
                  onChange={(e: any) => {
                    formik.setFieldValue("business_unit", e.value);
                  }}
                />
                <Button
                  onClick={() => setAddBU(true)}
                  text="Add"
                  type="button"
                  className="h-fit w-fit py-2.5"
                />
              </div>
            </div>
          )}

          {showJdAttachment ? (
            <>
              <FileUpload
                value={selectedFile ? selectedFile.name : ""}
                onChange={handleImageChange}
                accept=".pdf,.docx"
                label="Attachment"
                placeholder={"No file chosen"}
                maxSizeMB={3}
                isError={!!fileError}
                errorMessage={fileError}
                disabled={false}
                required={false}
                isDelete={true}
                isCamera={false}
              />
            </>
          ) : (
            <>
              <div className="flex flex-col gap-1.5">
                <Label text="Attachment" />
                <div className="flex gap-2 items-end">
                  <Button
                    text="View File"
                    type="button"
                    variant="outlined"
                    className="w-[70%] "
                    disabled={!templateJdattachment}
                    onClick={() => window.open(templateJdattachment, "_blank")}
                  />
                  <Button
                    text="Change"
                    type="button"
                    className="w-[30%]"
                    onClick={() => setShowJdAttachment(true)}
                  />
                </div>
              </div>
            </>
          )}

          <CustomInput
            name="remarks"
            label="Remarks"
            value={formik.values.remarks}
            onChange={formik.handleChange}
          />

          <div className="flex flex-col gap-1.5 ">
            <div className="flex items-center gap-2">
              <Label text="Additional Skill" />
              <Tooltip
                className="w-72 flex-wrap"
                tooltipText="Add Skillsets to the drop-down so you can easily use them next time you create a Job Description."
                children={<BsInfoCircle size={12} color="blue" />}
              />
            </div>
            <div className="flex gap-2">
              <CustomInput
                placeholder="Additional Skill"
                type="text"
                name="additional_skill"
                value={formik.values.additional_skill}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                isError={
                  !!formik.touched.additional_skill &&
                  !!formik.errors.additional_skill
                }
                errorMessage={formik.errors.additional_skill}
                className={"border-none"}
              />
              <Button
                onClick={() => addNewSkill()}
                text="Add"
                className="h-fit py-2.5"
                disabled={formik.values.additional_skill === ""}
              />
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <MultiSelectDropdown
              label="Required Technical Skills"
              options={skillList}
              initialOptions={primary}
              position="top"
              onChange={(selectedOptions) => {
                var data: any = [];
                var wtg = 0;
                wtg = 100 / (selectedOptions.length + secondary.length);
                var add = 0;
                if (
                  Math.floor(wtg) *
                    (selectedOptions.length + secondary.length) <
                  100
                ) {
                  add =
                    100 -
                    Math.floor(wtg) *
                      (selectedOptions.length + secondary.length);
                }
                selectedOptions.map((e: any, index: number) => {
                  data.push({
                    id: e["id"],
                    name: e["name"],
                    year: 0,
                    month: 0,
                    weightage:
                      index === 0 ? Math.floor(wtg) + add : Math.floor(wtg),
                    weightage_error: "",
                  });
                });
                setPrimary(data);
                setSecondary((prevItems: any) =>
                  prevItems.map((item: any) => ({
                    ...item,
                    weightage: Math.floor(wtg),
                  })),
                );
                formik.values.primary_skill = data;
                serPrimaryError("");
              }}
              placeholder="Select primary skills"
              disabled={selectedJdTemplate ? true : false}
              isError={!!primary_error}
              errorMessage="Please select the Required Technical skills"
              required
            />
            <div className="flex flex-wrap gap-1 border h-14  overflow-y-scroll no-scrollbar border-gray-300 rounded-lg p-1">
              {primary.map((skill: any) => (
                <div
                  key={skill.id}
                  className="text-[10px] bg-primary text-white w-fit h-fit flex items-center gap-1 rounded-2xl  p-1"
                >
                  <div>{skill.name}</div>
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      const updatedPrimary = primary.filter(
                        (item: any) => item.id !== skill.id,
                      );
                      setPrimary(updatedPrimary);
                    }}
                  >
                    <IoCloseCircleOutline size={12} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <MultiSelectDropdown
              label="Preferred Technical Skills"
              options={skillList}
              position="top"
              initialOptions={secondary}
              onChange={(selectedOptions) => {
                let data: any = [];
                var wtg = 0;
                wtg = 100 / (selectedOptions.length + primary.length);
                var add = 0;
                if (
                  Math.floor(wtg) * (selectedOptions.length + primary.length) <
                  100
                ) {
                  add =
                    100 -
                    Math.floor(wtg) * (selectedOptions.length + primary.length);
                }
                selectedOptions.map((e: any, index: number) => {
                  var data1 = secondary.filter(
                    (item: any) => item.id === e["id"],
                  );
                  if (data1.length === 0) {
                    data.push({
                      id: e["id"],
                      name: e["name"],
                      year: 0,
                      month: 0,
                      weightage:
                        index === 0 ? Math.floor(wtg) + add : Math.floor(wtg),
                      weightage_error: "",
                    });
                  } else {
                    data.push({
                      id: e["id"],
                      name: e["name"],
                      year: 0,
                      month: 0,
                      weightage:
                        index === 0 ? Math.floor(wtg) + add : Math.floor(wtg),
                      weightage_error: "",
                    });
                  }
                });
                serSecondaryError("");
                setSecondary(data);
                setPrimary((prevItems: any) =>
                  prevItems.map((item: any) => ({
                    ...item,
                    weightage: Math.floor(wtg),
                  })),
                );
                formik.values.secondary_skill = data;
              }}
              placeholder="Select preferred skills"
              disabled={selectedJdTemplate ? true : false}
              isError={!!secondary_error}
              errorMessage="Please select the Preferred Technical skills"
              required
            />

            <div className="flex flex-wrap gap-1 border h-14 overflow-y-scroll no-scrollbar border-gray-300 rounded-lg p-1">
              {secondary.map((skill: any) => (
                <div
                  key={skill.id}
                  className="text-[10px] bg-primary text-white w-fit h-fit flex items-center gap-1 rounded-2xl p-1"
                >
                  <div>{skill.name}</div>
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      const updatedSecondary = secondary.filter(
                        (item: any) => item.id !== skill.id,
                      );
                      setSecondary(updatedSecondary);
                    }}
                  >
                    <IoCloseCircleOutline size={12} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <TextArea
            name="job_description"
            label="Job Description"
            value={formik.values.job_description}
            onChange={formik.handleChange}
            rows={4}
            className="col-span-2"
            isError={
              !!formik.touched.job_description &&
              !!formik.errors.job_description
            }
            errorMessage={formik.errors.job_description}
            required
          />
          <div className=" gap-2 flex col-span-2 lg:col-span-4  justify-end items-end ">
            {selectedJdTemplate && (
              <Button
                text="Edit"
                type="button"
                variant="outlined"
                className="h-fit"
                onClick={() => setSelectedTemplate("")}
              />
            )}
            <Button
              text="Reset"
              type="button"
              variant="outlined"
              className="h-fit"
              onClick={() => {
                resetJd();
                resetClientAndTemplate();
              }}
            />
            <Button
              text="Save & Next"
              type="submit"
              className="h-fit"
              disabled={isDisabled}
            />
          </div>
        </div>
      </form>

      <Modal
        isOpen={addBU}
        onClose={() => setAddBU(false)}
        title="Add Business Unit"
        children={
          <div className="flex w-full gap-1">
            <CustomInput
              name="new_business_unit"
              placeholder="Enter Business Unit"
              type="text"
              value={formik.values.new_business_unit}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              className="w-full"
            />
            <Button onClick={() => addNewBu()} text="Add" type="button" />
          </div>
        }
      />
    </>
  );
};

export default UploadJd;
